import { Route } from '@angular/router';
import { CreateTenderComponent } from '../../../layouts';
import {
    createTenderDetailsRoute,
    createTenderContractsRoute,
    createTenderSuppliersRoute,
    createTenderReviewRoute
} from './children';
import { TenderResolver } from '../../resolvers';
import { TenderStatusGuard } from '../../guards';

export const createTenderRoutes: Route = {
    path: 'tenders/new/:id',
    component: CreateTenderComponent,
    resolve: {
        tender: TenderResolver
    },
    canActivate:[TenderStatusGuard],
    children: [
        {
            path: '',
            redirectTo: 'details',
            pathMatch: 'prefix'
        },
        createTenderDetailsRoute,
        createTenderContractsRoute,
        createTenderSuppliersRoute,
        createTenderReviewRoute,
    ]
};
